module.exports = __webpack_public_path__ + "img/ertiga-boostergreen.26d08a15.png";